import React from "react";
import "./styles.css";
import Alliances from "../../alliances";
import Footer from "../../UI/footer";
import AlliancesInfo from "../../alliances-info";
import AlliancesTypes from "../../alliances-types";
import AlliancesForm from "../../alliances-form";

function Allies() {
  return (
    <div className="allies">
      <AlliancesInfo />
      <AlliancesTypes />
      <AlliancesForm />
      <Alliances />
      <Footer />
    </div>
  );
}

export default Allies;
